import { render } from "./modalCompany.vue?vue&type=template&id=257f26f0"
import script from "./modalCompany.vue?vue&type=script&lang=js"
export * from "./modalCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__